(() => {
    const GLOBAL_KEY = "__mbVideoController";
    const WRAPPER_SELECTOR = "[data-video-wrapper], [data-media-player]";

    function collectWrappers(root) {
        if (!root) return [];

        const wrappers = [];

        if (root instanceof Element && root.matches(WRAPPER_SELECTOR)) {
            wrappers.push(root);
        }

        if (typeof root.querySelectorAll === "function") {
            wrappers.push(...root.querySelectorAll(WRAPPER_SELECTOR));
        }

        return wrappers;
    }

    function setupWrapper(wrapper, observers) {
        if (wrapper.dataset.mbVideoControllerReady === "true") return;

        const video = wrapper.querySelector("video");
        const button = wrapper.querySelector(".play-btn, .media-player__play-button");
        const autoplayEnabled =
            wrapper.dataset.videoAutoplay === "true" || wrapper.dataset.autoplay === "true";

        if (!video) return;

        const attemptPlay = () => {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch(() => { });
            }
        };

        // PLAY BUTTON
        if (button) {
            button.addEventListener("click", () => {
                if (video.paused) {
                    attemptPlay();
                } else {
                    video.pause();
                }
            });
        }

        // UI STATE
        if (!wrapper.hasAttribute("aria-started")) {
            wrapper.setAttribute("aria-started", "false");
        }

        const syncUiState = () => {
            wrapper.setAttribute("aria-playing", video.paused ? "false" : "true");
        };

        video.addEventListener("play", syncUiState);
        video.addEventListener("pause", syncUiState);
        video.addEventListener("ended", syncUiState);
        video.addEventListener(
            "play",
            () => {
                wrapper.setAttribute("aria-started", "true");
            },
            { once: true }
        );

        if (autoplayEnabled) {
            video.muted = true;
        }

        syncUiState();

        if (autoplayEnabled) {
            attemptPlay();
        }

        // INTERSECTION OBSERVER
        if (typeof IntersectionObserver === "function") {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting && !video.paused) {
                            video.pause();
                        }

                        if (entry.isIntersecting && autoplayEnabled && video.paused) {
                            attemptPlay();
                        }
                    });
                },
                { threshold: 0.4 }
            );

            observer.observe(wrapper);
            observers.set(wrapper, observer);
        }

        // 🔥 LOOP START / END DINAMICO
        const start = parseFloat(video.dataset.start || 0);
        const end = parseFloat(video.dataset.end || 0);

        if (end && end > start) {

            let initialized = false;

            const setStart = () => {
                if (initialized) return;
                initialized = true;

                try {
                    video.currentTime = start;
                } catch (e) { }
            };

            // 🔥 forza subito
            setStart();

            // 🔥 e quando pronto
            video.addEventListener("loadedmetadata", setStart);

            // 🔥 sicurezza extra
            video.addEventListener("canplay", setStart);

            // 🔁 loop preciso
            video.addEventListener("timeupdate", () => {
                if (video.currentTime >= end) {
                    video.currentTime = start;
                }
            });
        }

        wrapper.dataset.mbVideoControllerReady = "true";
    }

    function teardown(root, observers) {
        const wrappers = collectWrappers(root);

        wrappers.forEach((wrapper) => {
            const observer = observers.get(wrapper);
            if (observer) {
                observer.disconnect();
                observers.delete(wrapper);
            }

            delete wrapper.dataset.mbVideoControllerReady;
        });
    }

    if (window[GLOBAL_KEY]) {
        window[GLOBAL_KEY].init(document);
        return;
    }

    const observers = new WeakMap();

    function init(root = document) {
        const wrappers = collectWrappers(root);
        wrappers.forEach((wrapper) => setupWrapper(wrapper, observers));
    }

    document.addEventListener("DOMContentLoaded", () => init(document));
    document.addEventListener("shopify:section:load", (event) => init(event.target));
    document.addEventListener("shopify:section:unload", (event) => teardown(event.target, observers));

    window[GLOBAL_KEY] = { init };
})();